import CloseIcon from '@mui/icons-material/Close';
import { DialogActions, DialogContent, IconButton, Typography } from '@mui/material';

import { DialogButton } from '@/components/Dialog';
import Loader from '@/components/Loader';
import { spacing } from '@/constants/ui';
import copyToClipboard from '@/utils/copyToClipboard';

import useGenerationBody from './useGenerationBody';

const PostGenerationBody = ({ handleClose }: { handleClose: () => void }) => {
  const { listApiKeyState, exportToCsv } = useGenerationBody();

  if (listApiKeyState.status === 'failed') {
    return (
      <>
        <DialogContent>
          <Typography>Error generating ApiKey</Typography>
          <Typography>Please contact the General Index support team.</Typography>
        </DialogContent>
        <DialogActions sx={{ mt: spacing[2] }}>
          <DialogButton
            variant='text'
            onClick={handleClose}
          >
            Close
          </DialogButton>
        </DialogActions>
      </>
    );
  }
  if (listApiKeyState.status === 'loading') {
    return <Loader />;
  }
  return (
    <>
      <IconButton
        aria-label='close'
        sx={{
          position: 'absolute',
          right: 16,
          top: 16,
          color: 'text.primary'
        }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <Typography>Your token has been created. You can now retrieve the API token.</Typography>

      <DialogActions sx={{ mt: spacing[2] }}>
        <DialogButton
          variant='outlined'
          onClick={() =>
            copyToClipboard(
              listApiKeyState.apiKeyOutputs.at(-1)?.prefixedRawApiKey ?? '',
              'Api key copied to clipboard!'
            )
          }
        >
          Copy token
        </DialogButton>
        <DialogButton
          variant='outlined'
          onClick={exportToCsv}
        >
          Download as CSV file
        </DialogButton>
      </DialogActions>
    </>
  );
};

export default PostGenerationBody;
